export default __webpack_public_path__ + "images/loggedout/home/tick-icon-dark-purple-6300662090b577b77dd9a4aaadd0bfb6.svg";